import { useAllFollowUpsQuery, useMissedAppsTagId } from '../../../shared';
import moment from 'moment';

export function useOutdatedFollowUps(agentId?: string) {
  const missingAppsTagId = useMissedAppsTagId();
  const {data} = useAllFollowUpsQuery({
    fetchPolicy: 'cache-and-network',
    variables: {
      agentId,
      excludedTagsIds: [missingAppsTagId],
      includedTagsIds: undefined ,
    },
    skip: !agentId || !missingAppsTagId,
  })

  return data?.allFollowUps?.data.filter(c => moment(c.followUpDate).isBefore(moment().startOf('day')))
}
